import React from "react";
import RankingScreen from "../../Ranking";

const Screen27 = () => {
    return <RankingScreen />;
};

export default Screen27;
